'use client'
import { HydrationBoundary, type DehydratedState } from '@tanstack/react-query'
import { PageRetailerContextProvider } from '@/features/shared/context/RetailerContext'
import { ExperimentsContextProvider } from '@/features/shared/context/ExperimentsContext'
import { FeatureFlagsContextProvider } from '@/features/shared/context/FeatureFlagsContext/FeatureFlagsContextProvider'
import { type PageRouteData } from '@/features/shared/utils/setPageProps'
import { SessionQueryControllers } from '@/features/shared/utils/dataFetching/reactQuery/SessionQueryControllers'

type Props = {
  children: React.ReactNode
  routeData: PageRouteData
  dehydratedState?: DehydratedState
}

export const CoreProviders = ({ children, routeData, dehydratedState }: Props) => {
  return (
    <HydrationBoundary state={dehydratedState}>
      <FeatureFlagsContextProvider>
        <ExperimentsContextProvider>
          <PageRetailerContextProvider isRetailerShoppingContext={!!routeData?.storeRequired}>
            <SessionQueryControllers />
            {children}
          </PageRetailerContextProvider>
        </ExperimentsContextProvider>
      </FeatureFlagsContextProvider>
    </HydrationBoundary>
  )
}
